import {CurrentSkedTask, ProjectTask} from 'src/app/core/model/task';
import {TaskPercentComplete} from '../model/task-percent-complete';

export function getTaskPercentComplete(task: CurrentSkedTask | ProjectTask): TaskPercentComplete {
  const doneCount = task.subtasks?.filter(subtask => subtask.complete)?.length || 0;
  return {
    percent: Math.round((doneCount / task.subtasks?.length) * 100),
    display: `${doneCount}/${task.subtasks?.length || 0}`,
  };
}
